module.exports = __webpack_public_path__ + "app/assets/images/menu.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/menu.png
// module id = 279
// module chunks = 7